import { useFirebaseContext } from '@medely/ui-kit';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';
import CenteredLoader from 'components/CenteredLoader';
import Login from './Login';

export default function MobileAuthLogin() {
  const { signInWithToken, googleUser } = useFirebaseContext();
  const location = useLocation();
  const [mobileToken] = useQueryParam('mobileToken', StringParam);
  const [error, setError] = useState<string | undefined>(undefined);

  const handleRedirect = () => {
    const urlParams = new URLSearchParams(location.search);
    const hasRedirect = urlParams.has('redirect');

    if (hasRedirect) {
      const params = urlParams.get('params');
      const url = params
        ? `${urlParams.get('redirect').concat(params)}`
        : `${urlParams.get('redirect')}`;
      return window.location.replace(url);
    }

    window.location.replace('/');
  };

  useEffect(() => {
    const signInAndRedirect = async (mobileToken: string) => {
      try {
        await signInWithToken(mobileToken);
        handleRedirect();
      } catch (e) {
        console.error(e);
        setError(e);
      }
    };

    if (mobileToken) {
      signInAndRedirect(mobileToken);
    }
  }, [googleUser, mobileToken]);

  return <>{!!error ? <Login /> : <CenteredLoader />}</>;
}
